export const formatTokenBalance = (value?: string | number): string => {
  if (value === undefined || value === null) return '0'
  const num = Number(value)
  if (!isFinite(num) || isNaN(num)) return '0'
  if (num > 0 && num < 0.000001) return '< 0.000001'
  return num.toFixed(6)
}

export const formatUSDBalance = (value?: string | number): string => {
  if (value === undefined || value === null) return '0.00'
  const num = Number(value)
  if (!isFinite(num) || isNaN(num)) return '0.00'
  if (num > 0 && num < 0.00001) return '< 0.00001$'
  return `$${num.toFixed(4)}`
}

